import React, { useEffect } from 'react'
import { useQuery } from '../utility/util';
import { useParams } from 'react-router-dom';

export default function OAuthPage() {
    const query = useQuery();

    const { origin } = useParams();
    const code = query.get("code");
    const error = query.get("error");
    const state = query.get("state");

    useEffect(() => {
        const { host } = JSON.parse(state ?? "{}");
        if (host) {
            window.location.href = `http://${host}/oauth/${origin}?code=${code}&error=${error}`;
        } else if (window.opener) {
            // Send OAuth result back to parent window via postMessage
            window.opener.postMessage({
                type: 'oauth_code',
                origin,
                code: code || undefined,
                error: error || undefined
            }, window.location.origin);
            window.close();
        } else {
            // Fallback: store in localStorage if opener is not available
            if (code) localStorage.setItem(`${origin}_oauth_code`, code);
            if (error) localStorage.setItem(`${origin}_oauth_error`, error);
            window.close();
        }
    }, [code, error, origin, state]);

    return <div></div>

}